import { useTrackedLinkHandler } from '@app/analytics/utils';
import { ClearIcon } from '@app/components/icons/clear';
import { PlayButton } from '@app/components/icons/play-button';
import { FLAG_SPACES } from '@app/feature-flags/flags';
import { useFlags } from '@app/hooks/use-flags';
import introductionImage from '@app/routes/content/assets/content-hub-introduction.png';
import { buildCanvasEditorUrl } from '@app/routes/content/routes/utils';
import { selectCurrentSpaceExternalId } from '@app/routes/organization/selectors';
import { useAppSelector } from '@app/store';
import { getOrganizationId } from '@app/store/selectors';
import { Dialog } from '@headlessui/react';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { useState } from 'react';

export const Introduction = () => {
  const organizationId = useAppSelector(getOrganizationId);
  const { t } = useTranslation();
  const [showVideoModal, setShowVideoModal] = useState(false);
  const flags = useFlags();
  const spaceExternalId = useAppSelector(selectCurrentSpaceExternalId);

  const handleCreateHubClick = useTrackedLinkHandler('ch_hubs_create_hub', {
    source: 'empty_asset',
  });

  return (
    <>
      <div className="flex justify-between items-center border border-gray-300 rounded-[2.375rem] overflow-hidden mt-12 p-6 gap-4 max-w-5xl m-auto flex-basis-1/2">
        <div className="flex flex-col flex-grow-0 w-1/2 px-4">
          <div className="font-medium font-larsseit text-3xl mb-4">
            {t('content-hub.empty-state.title')}
          </div>
          <p className="text-gray-600 mb-4">
            {t('content-hub.empty-state.description-part1')}
          </p>
          <p className="text-gray-600 mb-4">
            {t('content-hub.empty-state.description-part2')}
          </p>
          <a
            href={buildCanvasEditorUrl(`/org/${organizationId}/page/create`, {
              spacesEnabled: Boolean(flags?.[FLAG_SPACES]),
              spaceExternalId,
            })}
            onClick={handleCreateHubClick}
            className="h-10 w-max rounded-[0.625rem] bg-primary text-sm inline-flex items-center justify-center text-white px-5 font-medium outline-none hover:text-white hover:bg-blue-600 no-underline"
          >
            {t('content-hub.create-content-hub')}
          </a>
        </div>

        <button
          onClick={() => setShowVideoModal(true)}
          className="relative rounded-[0.875rem] overflow-hidden w-1/2"
        >
          <div className="absolute rounded-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 items-center justify-center">
            <PlayButton
              className="text-white size-10"
              iconClassName="text-blue-500"
            />
          </div>
          <img src={introductionImage} alt="" role="presentation" />
        </button>
      </div>
      <Dialog open={showVideoModal} onClose={() => setShowVideoModal(false)}>
        <div className="bg-black/85 fixed inset-0 z-[210]" aria-hidden="true" />
        <Dialog.Panel className="fixed inset-0 m-auto flex flex-col items-center justify-center py-12 px-20 z-[220]">
          <button
            className="z-[230] absolute top-4 right-4 rounded-full w-11 h-11 inline-flex justify-center items-center bg-white text-black"
            onClick={() => setShowVideoModal(false)}
          >
            <ClearIcon name="close" className="text-gray-650" />
            <span className="sr-only">{t('common.close')}</span>
          </button>
          <div className=" relative overflow-hidden aspect-video w-[80vw] h-auto landscape:w-auto landscape:h-[70vh] xl:max-w-[1280px] xl:max-h-[720px]">
            <iframe
              width="100%"
              height="1080"
              src="https://www.youtube.com/embed/4y52T5a3Qyg?si=-i5qSperg5copRnC&autoplay=1&cc_load_policy=1&color=white&controls=0&iv_load_policy=3&rel=0&showinfo=0&hd=1"
              title="Get Started fwith RingCentral Events"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full border-0"
            />
          </div>
        </Dialog.Panel>
      </Dialog>
    </>
  );
};
